import {categoryUrlBuilder, searchUrlBuilder} from '@salesforce/retail-react-app/app/utils/url'
import {productUrlBuilder} from '../../../utils/url'
import routingObject from '../../../utils/static-routes'
import {decodeHtmlEntities} from '../../../utils/utils'

export default function formatSuggestions(searchSuggestions, input) {
    return {
        categorySuggestions: searchSuggestions?.categorySuggestions?.categories?.map(
            (suggestion) => {
                return {
                    type: 'category',
                    id: suggestion.id,
                    link: suggestion.c_slugUrl || categoryUrlBuilder({id: suggestion.id}),
                    name: suggestion.name,
                }
            },
        ),
        productSuggestions: searchSuggestions?.productSuggestions?.products?.map((product) => {
            return {
                type: 'product',
                currency: product.currency,
                price: product.price,
                productId: product.productId,
                name: product.productName,
                link: productUrlBuilder(product),
            }
        }),
        phraseSuggestions: searchSuggestions?.categorySuggestions?.suggestedPhrases?.map(
            (phrase) => {
                return {
                    type: 'phrase',
                    name: phrase.phrase,
                    link: searchUrlBuilder(phrase.phrase),
                }
            },
        ),
        articleSuggestions: searchSuggestions?.articleSuggestions?.map((article) => {
            if (!input || !article?.article_title) return
            let articleCategory = decodeHtmlEntities(article?.article_category)
                .trim()
                .replace(/\s+/g, '-')
                .replace(/[?]/g, '')
            return {
                type: 'article',
                id: article?.article_id,
                link: `${routingObject.FAQ_PATH}/${articleCategory}/a/${article?.article_id}`,
                name: article?.article_title,
            }
        }),
    }
}
